export const TextArea = ({
  label,
  sublabel,
  placeholder,
  validation,
  submit,
  name,
  value,
  onInputChange,
  rows = 3,
  disabled
}) => {
  return (
    <>
      {label && (
        <label className="form-label text-gray-600 mb-0">
          {label} <span className="text-gray-300 fs-sm">{sublabel}</span>
        </label>
      )}
      <textarea
        className={`form-control ${validation && submit && "border-danger"}`}
        placeholder={placeholder}
        name={name}
        value={value ?? ""}
        onChange={onInputChange}
        rows={rows}
        disabled={disabled}
      ></textarea>
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </>
  );
};
